import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ConfigService } from "src/app/services/config/config.service";

@Directive({
    selector: '[cdnImage]'
})

export class CDNImageDirective implements OnInit, OnChanges {

    @Input() imageName: string;
    @Input() isEnabled = true;

    protected cdnPath: string = this.config?.cdnUrl;

    constructor(
        private el: ElementRef,
        private readonly config: ConfigService
    ) {

    }

    ngOnInit(): void {
        this.updateBackgroundImage();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.imageName && changes.imageName.currentValue) {
            this.updateBackgroundImage();
        }
    }

    private updateBackgroundImage(): void {
        if (this.isEnabled) {
            this.el.nativeElement.style.backgroundImage = `url(${this.cdnPath}/assets/${this.imageName})`;
        } 
    }
 
    
}